// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutReviewAndSubmitHeaderStyles } from "@tps/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.container = {
    css: css`
        padding-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
    `,
};

checkoutReviewAndSubmitHeaderStyles.headingText = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
    `,
};
